import { Pipe, PipeTransform } from '@angular/core';
import { formatCentenarioUnitsDisplay } from '../utils/centenario-currency-display';

@Pipe({
  name: 'centenarioUnits',
})
export class CentenarioUnitsPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return formatCentenarioUnitsDisplay(null);
    }
    const numeric = typeof value === 'number' ? value : Number(value);
    return formatCentenarioUnitsDisplay(Number.isNaN(numeric) ? 0 : numeric);
  }
}
